module.exports = __webpack_public_path__ + "static/media/cabinet-video.c8c4bbdf.webp";